import { Position } from '@/components/organisms/ChartGraph';

const colors: Record<string, string> = {
	Matriz: '#193CB9',
	Alagoas: '#001746',
	'Tucano Sul': '#1FBCDC',
	'Terminal Aquaviário de Maceió (TAMAC)': '#236BFF',
	ADM: '#A9C1FD',
	TURNO: '#D4D9FF',
};

export const getBackgroundColor = (text: string) => {
	if (Object.keys(colors).includes(text)) {
		return colors[text];
	}
	return 'FFFFFF';
};

export const getBgColorByPositionInfo = (
	position: Position,
	active: boolean = true,
) => {
	const companyName = position.board.company?.name;
	const pole = position.workStation.pole;

	if (!active) {
		return 'bg-[#C4C4C4]';
	}

	switch (companyName) {
		case 'TAMAC':
			return 'bg-[#19B986]';
		case 'UTE':
			return 'bg-[#FF9F1C]';
	}

	if (pole === 'Alagoas') {
		return 'bg-black';
	}

	const poleColor = getBackgroundColor(pole);
	return `bg-[${poleColor}]`;
};
